import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker, DatePickerProps, DateValidationError, PickerChangeHandlerContext } from "@mui/x-date-pickers-pro";
import "dayjs/locale/nl";
import dayjs, { Dayjs } from "dayjs";
dayjs.locale("nl");

//@ts-ignore
export type WcDatePickerV2Props = DatePickerProps<Dayjs> & {
  controlDisabled?: boolean;
  children?: ReactNode;
  width?: number | string;
  required?: boolean;
  error?: any;
  format?: string;
  textFieldFullWidth?: boolean;
  fullWidth?: boolean;
  // If RHF might store string/Date, you can extend this type:
  value?: Dayjs | string | Date | null;
};

export const WcDatePickerV2 = (props: WcDatePickerV2Props) => {
  const { controlDisabled, width, required, error, format, value, fullWidth, slotProps, sx, onChange, ...rest } = props;

  // Normalize to Dayjs | null for the MUI picker
  const parsedValue: Dayjs | null = value == null ? null : dayjs(value as any);

  const handleChange = (newValue: Dayjs | null, context: PickerChangeHandlerContext<DateValidationError>) => {
    if (onChange) {
      onChange(newValue as any, context as any);
    }
  };

  return (
    <Box width={width ? width : fullWidth ? "100%" : 230} id="WcDatePickerV2">
      <LocalizationProvider adapterLocale="nl" dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          disabled={controlDisabled}
          format={format ?? "DD/MM/YYYY"}
          value={parsedValue}
          onChange={handleChange}
          slotProps={{
            ...slotProps,
          }}
          {...rest}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default WcDatePickerV2;
